import { observer } from 'mobx-react';
import { FC, useCallback, useEffect, useState } from 'react';
import { INavClick, NavPage, Nav, NavItem } from '@monorepo/base/src/components/nav/nav';
import { route } from '@monorepo/tools/src/lib/types/url';
import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import routes from '../../../modules/routes/index.routes';
import { Page } from '@monorepo/base/src/components/page/page';
import { Outlet } from 'react-router-dom';
import { IAdminxStore } from '../../../modules/stores';

export const Tools: FC = observer(() => {
	const { currentRoute } = useRoute();
	const { webappsCidStore } = useStores<IAdminxStore>();
	const [activeRoute, setActiveRoute] = useState<route>(currentRoute);

	useEffect(() => {
		setActiveRoute(currentRoute);
	}, [currentRoute]);

	const onToolsTabClick = useCallback(
		({ to }: INavClick) => {
			webappsCidStore.listStore.abort();
			if (to) {
				setActiveRoute(to);
			}
		},
		[webappsCidStore]
	);

	return (
		<NavPage>
			<Nav onNavClick={onToolsTabClick} activeRoute={activeRoute}>
				<NavItem to={`${routes.tools.tool('cids')}`}>CIDs</NavItem>
				<NavItem to={`${routes.tools.tool('create-campaign-segmentation')}`}>Create Segmentation</NavItem>
				<NavItem to={`${routes.tools.tool('view-campaign-segmentation')}`}>View Segmentation</NavItem>
				<NavItem to={`${routes.tools.tool('replace-cids')}`}>Replace CID</NavItem>
			</Nav>
			<Page>
				<Outlet />
			</Page>
		</NavPage>
	);
});
